


















// @ is an alias to /src
import Vue from 'vue';
import MotionSearchView from '@/components/MotionSearchView.vue';
import ApiRequest from '@/util/apiRequest';

import { API_TAG_QUERY_ID, TITLE_TERMINATOR } from '../../util/config';

export default Vue.extend({
  name: 'home',
  data() {
    return {
      tagName: '',
      tagSynonyms: [],
      includeExplicit: false,
      queryReady: false,
    };
  },
  components: {
    MotionSearchView,
  },
  methods: {
    async load(nextRoute) {
      try {
        const response = await ApiRequest.Get(API_TAG_QUERY_ID + nextRoute.params.id);
        this.$data.tagName = response.name;
        this.$data.tagSynonyms = response.synonyms;
        document.title = response.name + TITLE_TERMINATOR;
        this.$data.queryReady = true;
      } catch (error) {
        if (error.statusCode === 404) {
          this.$data.categoryName = 'Not Found';
        } else {
          throw error;
        }
      }
    },
  },
  beforeRouteUpdate(to, from, next) {
    this.load(to);
    next();
  },
  computed: {
    query() {
      return {
        tags: [parseInt(this.$route.params.id, 10)],
        explicitMode: this.$data.includeExplicit ? 1 : 0,
      };
    },
  },
  mounted() {
    this.load(this.$route);
  },
});
